import styled from '@emotion/styled';
import { AgentChatbotWidget } from '@libs/agent-chat';
import { useReleaseFlag } from '@libs/contexts';
import { GlobalArea, NotificationProvider } from '@libs/templates/global-area';
import { BackDropSpinnerProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';
import { hasSandboxToken } from '../../../../libs/templates/src/global-area/services';
import {
  BooksProvider,
  CompanyProvider,
  CustomFieldSettingsProvider,
  MstSettingsProvider,
  OperationControlProvider,
  ProcessingMonthProvider,
} from '../context';
import { useCompany } from '../context/CompanyContext';
import { ProcessingMonthLabel } from './ProcessingMonthLabel';
import { SandboxLabel } from './SandboxLabel';

const LabelContainer = styled.div`
  display: flex;
  gap: 5px;
`;

export function AgentChatbotConnector() {
  const { company } = useCompany();
  const { isEnabled, isLoading } = useReleaseFlag('release.agent.chat_panel_v1');

  if (isLoading || !isEnabled) {
    return null;
  }

  return <AgentChatbotWidget companyCode={company.companyCode} />;
}

function ContainerWithContext() {
  return (
    <CompanyProvider>
      <ProcessingMonthProvider>
        <NotificationProvider>
          <BooksProvider>
            <MstSettingsProvider>
              <CustomFieldSettingsProvider>
                <OperationControlProvider>
                  <BackDropSpinnerProvider>
                    <GlobalArea homePath="/fa/main-menu">
                      <LabelContainer>
                        {hasSandboxToken() && <SandboxLabel />}
                        <ProcessingMonthLabel />
                      </LabelContainer>
                    </GlobalArea>
                    <Outlet />
                    <AgentChatbotConnector />
                  </BackDropSpinnerProvider>
                </OperationControlProvider>
              </CustomFieldSettingsProvider>
            </MstSettingsProvider>
          </BooksProvider>
        </NotificationProvider>
      </ProcessingMonthProvider>
    </CompanyProvider>
  );
}

export { ContainerWithContext };
